import Vue from 'vue'
import VueRouter from 'vue-router'
import { routerHistory, writeHistory } from 'vue-router-back-button'
import SHome from '@/components/home/Home.vue'
import SError from '@/components/layout/error/Error.vue'
import SActivate from '@/components/layout/activation/Activation.vue'

import SFormLogin from '@/components/login/Login.vue'
import SFormPassword from '@/components/login/GetPassword.vue'
import SAssignPassword from '@/components/login/AssignPassword.vue'

import SConfigurationAll from '@/components/admin/configuration/All.vue'

import SPermissions from '@/components/admin/Permissions.vue'
import SAllPermission from '@/components/admin/permissions/All.vue'
import SAssignPermissionsGroups from '@/components/admin/permissions/AssignGroup.vue'
import SProfiles from '@/components/admin/Profiles.vue'
import SAllProfiles from '@/components/admin/profiles/All.vue'
import SAllUsers from '@/components/admin/users/All.vue'
import SProfile from '@/components/profile/Profile.vue'
import SList from '@/components/layout/list/List.vue'
import SSection from '@/components/layout/section/Base.vue'
import SContact from '@/components/contact/Contacts.vue'
import SFaq from '@/components/contact/FAQs.vue'
import SAdminProperty from '@/components/property/AdminProperty.vue'
import SServicesAll from '@/components/admin/services/All.vue'
import SConfigAll from '@/components/admin/config/All.vue'
import SZoneAll from '@/components/admin/zone/All.vue'
import SCompanyAll from '@/components/admin/company/All.vue'
import SControlPointAll from '@/components/admin/control_points/All.vue'
import SVisitedAll from '@/components/admin/visited/All.vue'
import SAuthorizedTypesAll from '@/components/admin/authorized/authorized_types/All.vue'
import SDocumentsAll from '@/components/admin/authorized/documents/All.vue'
import SCredentialAll from '@/components/admin/credentials/All.vue'
import SLogs from '@/components/logs/All.vue'
import SNoveltyTypes from '@/components/admin/novelties/novelties_types/All.vue'
import SNoveltyAll from '@/components/admin/novelties/All.vue'
import SAccessProfileAll from '@/components/admin/access_profiles/All.vue'
import SAuthorizationAll from '@/components/admin/authorization/All.vue'
import SAuthorizationNew from '@/components/admin/authorization/New.vue'
import SAuthorizationEdit from '@/components/admin/authorization/Edit.vue'
import SAuthorizationCargoAll from '@/components/admin/cargo_authorization/All.vue'
import SAuthorizationCargoNew from '@/components/admin/cargo_authorization/New.vue'
import SAuthorizationCargoEdit from '@/components/admin/cargo_authorization/Edit.vue'
import SLanguagesAll from '@/components/admin/languages/All.vue'
import SPhrasesAll from '@/components/admin/languages/phrases/All.vue'
import SHolidayAll from '@/components/admin/holidays/All.vue'
import SSupport from '@/components/support/Support.vue'
import SReception from '@/components/reception/Reception.vue'
// import SReceptionCond from '@/components/reception/condominium/Reception.vue'
import SDepartmentAll from '@/components/admin/departments/All.vue'
import SDepartmentAuthorizedAll from '@/components/admin/departments/authorized/All.vue'
import SPermissionGroupAll from '@/components/admin/permissions/groups/All.vue'
import SPermissionGroupNew from '@/components/admin/permissions/groups/New.vue'
import SSiteAll from '@/components/admin/sites/All.vue'
import SReportAll from '@/components/admin/reports/All.vue'
import SSynComplete from '@/components/support/SyncComplete.vue'
import SSynControl from '@/components/support/SyncControl.vue'
import SManufacturer from '@/components/admin/cameras/Manufacturer.vue'
import SCamera from '@/components/admin/cameras/Camera.vue'
import STrafficBoard from '@/components/traffic_board/Traffic_board.vue'
import SMonitoring from '@/components/traffic_board/Monitoring.vue'
import Ssurveillance from '@/components/surveillance/Surveillance.vue'

import SAuthorizationAllCond from '@/components/admin/authorization/condominium/All.vue'
import SAuthorizationNewCond from '@/components/admin/authorization/condominium/New.vue'
import SAuthorizationEditCond from '@/components/admin/authorization/condominium/Edit.vue'

import SAdvanceSearch from '@/components/advance_search/AdvanceSearch.vue'
import SAdvancedBicycleandDisabled from '@/components/advance_search/BicyclesandDisable.vue'
import SAdvanceCargoVehicles from '@/components/advance_search/CargoVehicles.vue'
import SAdvanceForced from '@/components/advance_search/Forced.vue'
import SAdvanceVehicular from '@/components/advance_search/Vehicular.vue'

const routes = [
  { path: '/', component: SHome, name: 'home', meta: { auth: true, code: 0 } },
  { path: '/error', component: SError, name: 'error', meta: { auth: false, code: 0 } },
  { path: '/activate', component: SActivate, name: 'activate', meta: { auth: false, code: 0 } },
  { path: '/login/contact', component: SContact, name: 'loginContact', meta: { auth: false, code: 0 }, props: { login: true } },
  { path: '/login', component: SFormLogin, name: 'login', meta: { auth: false, code: 0 } },
  { path: '/select-property', component: SList, name: 'select-property', meta: { auth: true, code: 0 } },
  { path: '/reset-password/:id', component: SAssignPassword, name: 'resetPassword', meta: { auth: false, title: 'reset_password', btn_txt: 'reset', code: 0 } },
  { path: '/forget-password', component: SFormPassword, name: 'forgetPassword', meta: { auth: false, code: 0 } },
  { path: '/assign-password/:id', component: SAssignPassword, name: 'asignPassword', meta: { auth: false, title: 'assign_password', btn_txt: 'assign', code: 0 } },
  { path: '/profile/:id', component: SProfile, name: 'profile', meta: { auth: true, code: 1112 } },
  {
    path: '/admin/permissions',
    component: SPermissions,
    children: [
      { path: '', name: 'allPermissions', component: SAllPermission, meta: { auth: true, code: 1300 } }
    ]
  },
  { path: '/admin/profile/:id/groups', component: SAssignPermissionsGroups, meta: { auth: true, code: 1206 }, props: true },
  { path: '/admin/user', component: SAllUsers, meta: { auth: true, code: 1100 } },
  { path: '/admin/services', component: SServicesAll, meta: { auth: true, code: 2200 } },
  { path: '/admin/config/:id', name: 'configService', component: SConfigAll, meta: { auth: true, code: 2207 }, props: true },
  { path: '/admin/languages', component: SLanguagesAll, meta: { auth: true, code: 2300 } },
  { path: '/admin/phrases', component: SPhrasesAll, meta: { auth: true, code: 2307 } },
  {
    path: '/admin/profiles',
    component: SProfiles,
    children: [
      { path: '', name: 'allProfiles', component: SAllProfiles, meta: { auth: true, code: 1200 } }
    ]
  },
  { path: '/contact', component: SContact, meta: { auth: true, code: 0 } },
  { path: '/faq', component: SFaq, meta: { auth: true, code: 0 } },
  { path: '/sections', component: SSection, meta: { auth: true, code: 2100 } },
  { path: '/admin/property', name: 'adminProperty', component: SAdminProperty, meta: { auth: true, code: 30100 } },
  { path: '/admin/configuration', name: 'adminConfiguration', component: SConfigurationAll, meta: { auth: true, code: 2600 } },
  // { path: '/admin/configuration', name: 'adminConfiguration', component: SConfigurationAll, meta: { auth: true, code: 2100 } },
  { path: '/admin/companies', name: 'adminCompany', component: SCompanyAll, meta: { auth: true, code: 30200 } },
  { path: '/admin/control-points', name: 'adminControlPoints', component: SControlPointAll, meta: { auth: true, code: 30300 } },
  { path: '/admin/visited', name: 'visited', component: SVisitedAll, meta: { auth: true, code: 1600 } },
  { path: '/admin/zones', name: 'adminZone', component: SZoneAll, meta: { auth: true, code: 30400 } },
  { path: '/admin/holidays', name: 'adminHoliday', component: SHolidayAll, meta: { auth: true, code: 30500 } },
  { path: '/admin/authorized-types', name: 'authorized_types', component: SAuthorizedTypesAll, meta: { auth: true, code: 4100 } },
  { path: '/admin/staff-register', name: 'showStaff', component: SAuthorizationAll, meta: { auth: true, code: 4400 } },
  { path: '/admin/staff-register/new', name: 'createStaff', component: SAuthorizationNew, meta: { auth: true, code: 4403 }, params: { document: '' }, props: { is_cargo_prop: 0 } },
  { path: '/admin/staff-register/edit/:id', name: 'editStaff', component: SAuthorizationEdit, meta: { auth: true, code: 4406 }, props: { is_cargo_prop: 0 } },
  { path: '/admin/staff-register/cargo', name: 'showStaffCargo', component: SAuthorizationCargoAll, meta: { auth: true, code: 4400 } },
  { path: '/admin/staff-register/cargo/new', name: 'createCargoStaff', component: SAuthorizationCargoNew, meta: { auth: true, code: 4403 }, params: { document: '' }, props: { is_cargo_prop: 1 } },
  { path: '/admin/staff-register/cargo/edit/:id', name: 'editCargoStaff', component: SAuthorizationCargoEdit, meta: { auth: true, code: 4406 }, props: { is_cargo_prop: 1 } },
  { path: '/admin/staff-register-cond', name: 'showStaffCond', component: SAuthorizationAllCond, meta: { auth: true, code: 4417 } },
  { path: '/admin/staff-register/new-cond', name: 'createStaffCond', component: SAuthorizationNewCond, meta: { auth: true, code: 4418 }, params: { document: '' }, props: { is_cargo_prop: 0 } },
  { path: '/admin/staff-register/edit-cond/:id', name: 'editStaffCond', component: SAuthorizationEditCond, meta: { auth: true, code: 4420 }, props: { is_cargo_prop: 0 } },
  { path: '/admin/documents', name: 'documents', component: SDocumentsAll, meta: { auth: true, code: 4200 } },
  { path: '/admin/credentials', name: 'credentials', component: SCredentialAll, meta: { auth: true, code: 4300 } },
  { path: '/support', name: 'support', component: SSupport, meta: { auth: true, code: 10000 } },
  { path: '/reception', name: 'reception', component: SReception, meta: { auth: true, code: 1400 } },
  { path: '/reception-cond', name: 'receptionCond', component: SReception, meta: { auth: true, code: 1400 } },
  { path: '/logs', name: 'logs', component: SLogs, meta: { auth: true, code: 2500 } },
  { path: '/admin/novelties-types', name: 'noveltiesType', component: SNoveltyTypes, meta: { auth: true, code: 30600 } },
  { path: '/admin/novelties/:id', name: 'novelty', component: SNoveltyAll, meta: { auth: true, code: 4500 } },
  { path: '/admin/departments', name: 'adminDepartment', component: SDepartmentAll, meta: { auth: true, code: 30700 } },
  { path: '/admin/departments/authorized', name: 'adminDepartmentAuthorized', component: SDepartmentAuthorizedAll, meta: { auth: true, code: 30704 }, params: { department: '' } },
  { path: '/admin/access-profiles', name: 'accessProfile', component: SAccessProfileAll, meta: { auth: true, code: 30800 } },
  { path: '/admin/permissions/groups', name: 'permissionGroup', component: SPermissionGroupAll, meta: { auth: true, code: 1700 } },
  { path: '/admin/permissions/groups/new', name: 'createPermissionGroup', component: SPermissionGroupNew, meta: { auth: true, code: 1703 } },
  { path: '/admin/sites', name: 'adminSites', component: SSiteAll, meta: { auth: true, code: 30900 } },
  { path: '/admin/reports', name: 'adminReports', component: SReportAll, meta: { auth: true, code: 4000 } },
  { path: '/support/sync-complete', name: 'sync_complete', component: SSynComplete, meta: { auth: true, code: 5001 } },
  { path: '/support/sync-control', name: 'sync_control', component: SSynControl, meta: { auth: true, code: 0 } },
  { path: '/admin/cameras/list', name: 'cameras', component: SCamera, meta: { auth: true, code: 30350 } },
  { path: '/admin/cameras/manufacturer', name: 'manufacturers', component: SManufacturer, meta: { auth: true, code: 30350 } },
  { path: '/admin/traffic-board', name: 'traffic_board', component: STrafficBoard, meta: { auth: true, code: 6000 } },
  { path: '/admin/traffic-board/control-point/:id/:start_date/:end_date', name: 'monitoring', component: SMonitoring, meta: { auth: true, code: 6000 } },
  { path: '/admin/surveillance', name: 'surveillance', component: Ssurveillance, meta: { auth: true, code: 6000 } },
  { path: '/admin/advance-search', name: 'advanceSearch', component: SAdvanceSearch, meta: { auth: true, code: 1431 } },
  { path: '/admin/AdvanceBicyclesandDisabled', name: 'advanceBicyclesandDisabled', component: SAdvancedBicycleandDisabled, meta: { auth: true, code: 1432 } },
  { path: '/admin/AdvanceCargoVehicles', name: 'advanceCargoVehicles', component: SAdvanceCargoVehicles, meta: { auth: true, code: 1433 } },
  { path: '/admin/AdvanceForced', name: 'advanceForced', component: SAdvanceForced, meta: { auth: true, code: 1434 } },
  { path: '/admin/AdvanceVehicular', name: 'advanceVehicular', component: SAdvanceVehicular, meta: { auth: true, code: 1435 } }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

router.beforeEach(function (to, from, next) {
  const logged_in = router.app.$store.state.authentication.logged_in
  const shard = router.app.$store.state.authentication.user_shard
  const permissions = router.app.$store.getters.getUserPermissions
  if (to.meta.auth && !logged_in) {
    router.replace({ name: 'login' })
  } else if ((!to.meta.auth && to.meta.auth !== undefined) && logged_in) {
    router.replace({ name: 'home' })
  } else if (to.meta.auth && logged_in && (!shard || !shard.shard) && to.name !== 'select-property') {
    router.replace({ name: 'select-property' })
  } else {
    if (to.meta.code === 0) next()
    if (to.meta.code && permissions.find(p => { return (p.code === to.meta.code) })) {
      next()
    } else {
      router.resolve({ name: 'error' })
    }
  }
})
router.afterEach(writeHistory)
Vue.use(VueRouter)
Vue.use(routerHistory)

export default router



// WEBPACK FOOTER //
// app/javascript/src/routes/routes.js